import React from "react"
import { useStore } from "../teafuljs/store"
import SVLogo from "../../static/images/SVLogo.jpeg"
import BibleBackground from "../../static/images/BibleBackground.jpg"
import SEO from "../components/seo"
import "../../static/global.css"
import Typography from "@material-ui/core/Typography"
import { navigate } from "gatsby"
import IconButton from "@material-ui/core/IconButton"
import InsertChartOutlined from "@material-ui/icons/InsertChartOutlined"
import { getTranslation } from "../scripts/getTranslation"
import AppStoreLinks from "../components/AppStoreLinks/AppStoreLinks"
import ReaderImages from "../../static/images/ReaderPhoneImages.png"
import GAPImages from "../../static/images/GAPImages1.png"
import DataImages from "../../static/images/DataVisualizations.png"
import { makeStyles } from "@material-ui/core/styles"
import Button from "@material-ui/core/Button"
import bibleBookList from "../data/BookChapterList.json"
import IntroVideo from '../components/IntroVideo'
import SphereViewBlock from "../components/SphereViewBlock"
import Stepper from "../components/Stepper"
import Subtitle from "../components/Subtitle"

const useStyles = makeStyles(theme => ({
  mainTitle: {
    minWidth: "fit-content",
    margin: "90px auto 0 auto",
    textAlign: "center",
  },
  mainTitleSVB: {
    fontSize: "20px",
    margin: "1px",
    textAlign: "center",
  },
  mainTitleReader: {
    textTransform: "uppercase",
    fontSize: "45px",
    margin: "1px",
    lineHeight: "100%",
    fontWeight: "bold",
    textAlign: "center",
  },
  typography: {
    padding: theme.spacing(2),
    fontSize: "small",
    color: "white",
  },
  icons: {
    display: "flex",
    height: "fit-content",
    width: "100%",
    margin: "0 auto",
    flexDirection: "column",
    flexWrap: "nowrap",
    marginBottom: "20px",
  },
  SVLogo: {
    position: "relative",
    width: "200px",
    height: "200px",
    flex: "1",
    margin: "0 auto",
  },
  slogan: {
    fontStyle: "italic",
    textAlign: "center",
    fontSize: "150%",
    margin: "20px 0 0 0",
  },
  readNowDiv: {
    backgroundImage: `url(${BibleBackground})`,
    backgroundSize: "cover",
    marginLeft: "-12%",
    marginRight: "-12%",
    padding: "50px",
    textAlign: "center",
  },
  languageSelect: {
    position: "relative",
    width: "80%",
    textAlign: "center",
    margin: "20px auto",
    maxWidth: "450px",
    padding: "10px",
    borderRadius: "5px",
    backgroundColor: "white",
  },
  selectLanguage: {
    display: "flex",
    justifyContent: "space-around",
    width: "100%",
    flexWrap: "wrap",
    color: "black",
  },
  languageButton: {
    margin: "2px",
    width: "fit-content",
    fontWeight: "bold",
    fontSize: "110%",
  },
  overview: {
    margin: "10px 0 100px 0",
    display: "flex",
    justifyContent: "center",
  },
  // secondTitle: {
  //   backgroundColor: '#cad8ff',
  //   marginLeft: '-12%',
  //   marginRight: '-12%',
  //   padding: '25px'
  // },
  featureDivTitle: {
    fontWeight: "bold",
    textDecoration: "underline",
    margin: "0 auto 20px auto",
    // width: '60%',
    maxWidth: "500px",
  },
  featureLinks: {
    position: "relative",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  feature: {
    flex: "1 0 100px",
    margin: "5px",
    textAlign: "center",
    border: "1px red solid",
  },
  featureTitle: {
    color: "grey",
    textTransform: "uppercase",
    fontSize: "70%",
    fontWeight: "bold",
    lineHeight: "120%",
  },
  IconButton: {
    height: "54px",
    width: "auto",
    padding: "12px",
    textAlign: "center",
  },
  uniqueIcon: {
    height: "30px",
    width: "auto",
    margin: 0,
  },
  divider: {
    margin: "20px 0",
  },
  appLinks: {
    position: "relative",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: "0 0 100px 0",
    padding: "0 20px",
    // borderTop: `2px solid ${theme.palette.primary.main}`,
  },
  chartData: {
    position: "relative",
    width: 110,
    display: "flex",
    justifyContent: "center",
    margin: "100px auto",
    padding: 20,
    borderRadius: 15,
  },
  chartIcon: {
    height: 50,
    width: 50,
    backgroundColor: "white",
    borderRadius: 5,
  },
}))

const IndexPage = () => {
  const translations = useStore.translations()[0]
  const language = useStore.language()[0]
  const version = useStore.version()[0]
  const AvailableContent = useStore.AvailableContent()[0]
  const classes = useStyles()
  const [history, setHistory] = useStore.history()
  const [searchID, setSearchID] = useStore.searchID()
  const [currentSegmentID, setCurrentSegmentID] = useStore.currentSegmentID()
  const [currentBook, setCurrentBook] = useStore.currentBook()

  function findFirstAvailableBook(language, version) {
    const booksInOrder = Object.keys(bibleBookList)
    let firstBook = ""
    booksInOrder.forEach(book => {
      if (
        AvailableContent.content[language][version][book] !== undefined &&
        firstBook === ""
      ) {
        firstBook = book
      }
    })
    return firstBook
  }

  function navigateToReader() {
    setHistory([
      {
        page: window.location.pathname,
        language: language,
        version: version,
        segment: currentSegmentID,
        scrollY: window.scrollY,
      },
      ...history,
    ])
    if (
      AvailableContent.content[language][version][currentBook] &&
      AvailableContent.content[language][version][currentBook].segments.indexOf(
        currentSegmentID
      ) !== -1
    ) {
      navigate("/reader/")
    } else {
      const firstBookOfNewLanguage = findFirstAvailableBook(language, version)
      const firstSegmentOfNewLanguage =
        AvailableContent.content[language][version][firstBookOfNewLanguage]
          .segments[1]
      setCurrentSegmentID(firstSegmentOfNewLanguage)
      setCurrentBook(firstBookOfNewLanguage)
      navigate("/reader")
    }
  }
  console.log(language, AvailableContent)
  if (AvailableContent && language) {
    console.log(AvailableContent.content[language].language_code)
  }
  return (
    <div>
      <SEO title="Home" />
      {/* {language === "POR" ? (
        <div className={classes.mainTitle}>
          <p className={classes.mainTitleReader}>
            {getTranslation(translations, language, "UI", "home_title2")}
          </p>
          <h1 className={classes.mainTitleSVB}>
            {getTranslation(translations, language, "UI", "home_title1")}
          </h1>
        </div>
      ) : (
        <div className={classes.mainTitle}>
          <h1 className={classes.mainTitleSVB}>
            {getTranslation(translations, language, "UI", "home_title1")}
          </h1>
          <p className={classes.mainTitleReader}>
            {getTranslation(translations, language, "UI", "home_title2")}
          </p>
        </div>
      )} */}
      <div className={classes.icons}>
        {/* <img
          src={SVLogo}
          className={classes.SVLogo}
          alt="SourceView Bible Logo"
        /> */}
        <Typography variant="h1" className={classes.slogan}>
          {getTranslation(translations, language, "UI", "home_subtitle")}
        </Typography>
      </div>
      <Stepper />
      <p style={{ whiteSpace: "pre-line", marginTop: 20, textAlign: "center" }}>
        {getTranslation(
          translations,
          language,
          "UI",
          "opening_explanation_subtitle"
        )}
      </p>
      <Subtitle translationKey={"UI"} textId={"endless_discovery_title"} />
      <div style={{ maxWidth: 400, margin: "auto" }}>
        <img src={DataImages} alt="reader images" />
      </div>
      <p style={{ whiteSpace: "pre-line" }}>
        {getTranslation(translations, language, "UI", "endless_discovery_text")}
      </p>
      <Subtitle
        translationKey={"UI"}
        textId={"opening_explanation_text_read1"}
      />
      <div style={{ maxWidth: 400, margin: "auto" }}>
        <img src={ReaderImages} alt="reader images" />
      </div>
      <p style={{ whiteSpace: "pre-line" }}>
        {getTranslation(
          translations,
          language,
          "UI",
          "opening_explanation_text_read2"
        )}
      </p>
      <Subtitle
        translationKey={"UI"}
        textId={"opening_explanation_text_study1"}
      />
      <div style={{ maxWidth: 400, margin: "auto" }}>
        <img src={GAPImages} alt="reader images" />
      </div>
      <p style={{ whiteSpace: "pre-line" }}>
        {getTranslation(
          translations,
          language,
          "UI",
          "opening_explanation_text_study2"
        )}
      </p>

      <Subtitle translationKey={"UI"} textId={"revolution_title"} />
      <p style={{ whiteSpace: "pre-line" }}>
        {getTranslation(translations, language, "UI", "revolution_text")}
      </p>
      {/* <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginBottom: 30,
        }}
      >
        <Button
          style={{ width: 300, height: 100 }}
          data-cy="footerRead"
          size="large"
          color="secondary"
          variant="contained"
          className={classes.languageButton}
          onClick={() => navigateToReader()}
        >
          <span style={{ fontSize: 50 }}>
            {getTranslation(translations, language, "UI", "footer_nav_read")}
          </span>
        </Button>
      </div> */}
      {AvailableContent &&
        language &&
        AvailableContent.content[language].youTubeUrl && (
          <IntroVideo
            url={AvailableContent.content[language].youTubeUrl}
          />
        )}
      {/* <SphereViewBlock /> */}
      {/* <div className={classes.chartData}>
        <IconButton
          size="medium"
          color="inherit"
          aria-label="Menu"
          onClick={() => navigate("/dataCharts")}
        >
          <InsertChartOutlined className={classes.chartIcon} />
        </IconButton>
      </div> */}
      {language === "ENG" && (
        <div className={classes.appLinks}>
          <p>Other SourceView Tools:</p>
          <div
            style={{
              width: 100,
              height: 100,
              border: "1px solid grey",
              borderRadius: 10,
              marginBottom: 20,
              padding: 10,
            }}
          >
            <img src="https://play-lh.googleusercontent.com/FryO4j-dsOFPsjC4SmVPvjLImVpNrfxj2Cd9nMMbyR6qPiZKz7yCudvn-B9hM7OZcdL8=s360-rw" />
          </div>
          <AppStoreLinks />
        </div>
      )}
    </div>
  )
}

export default IndexPage
